import React, { useEffect, useState } from "react";
import * as go from "gojs";
import { ReactDiagram } from "gojs-react";
import Button from "@mui/material/Button";

const FxRoutingDiagram = (props) => {
    const [myAnimation, setMyAnimation] = useState(null);
    const [myDiagram, setMyDiagram] = useState(null); 
  

    // state variables 
    const nodeDataArray = props.hasOwnProperty("nodeData")? props.nodeData : [];
    const linkDataArray = props.hasOwnProperty("linkData")? props.linkData : [];
    const ugrpNo = props.hasOwnProperty("ugrpNo")? props.ugrpNo : '';
    const selectedSink = props.hasOwnProperty("selectedSink")? props.selectedSink : '';

    useEffect(() => {           
        if(myDiagram) myDiagram.alignDocument(go.Spot.Center, go.Spot.Center);
    },[props.nodeData,props.linkData]);

    const onChange = (e) => {  
        console.log(myDiagram);      
    };
      
    function handleModelChange(obj) {
        if (myDiagram === null) return;
        handleDiagramEvent(myDiagram);
    }

    function resetNodeBorders(diagram, base = "#c8c8c8") {
        if (!diagram) return;
        const m = diagram.model;
        m.startTransaction("hl-node");
        (m.nodeDataArray || []).forEach(nd => m.setDataProperty(nd, "color", base));
        m.commitTransaction("hl-node");
    }

    function highlightNodeBorder(diagram, node, color = "#2cc01eff") {
        if (!diagram || !node?.data) return;
        diagram.model.startTransaction("hl-node");
        diagram.model.setDataProperty(node.data, "color", color);
        diagram.model.commitTransaction("hl-node");
    }

    function highlightSourceNode(diagram, clickedNode, color = "#1e90ff") {
        if (!diagram || !clickedNode?.data?.sourceInlono) return;

        const parentInlo = Number(clickedNode.data.sourceInlono);

        // inloNo로 노드 찾기
        const it = diagram.findNodesByExample({ inloNo: parentInlo });
        const parentNode = it.first();                // GoJS Iterator -> 첫 노드

        if (!parentNode) return;

        diagram.model.startTransaction("highlight-source-node");
        diagram.model.setDataProperty(parentNode.data, "color", color); // ← stroke 바뀜
        diagram.model.commitTransaction("highlight-source-node");
    }

   function resetLinkColors(diagram, base = "#b0b0b0") {
       if (!diagram) return;
        diagram.startTransaction("reset-link-colors");
        diagram.links.each(l => {
            if (l.data) diagram.model.setDataProperty(l.data, "color", base);
        });
        diagram.commitTransaction("reset-link-colors");
   }

    function highlightPath_Inlo(diagram, startInloNo, targetInloNo, color = "#ff6b6b") {
    if (!diagram) return;
    const m = diagram.model;
    const links = m.linkDataArray || [];

    const adj = new Map();           // u -> Set(v)
    const edgeMap = new Map();       // "u->v" -> linkData

    const addEdge = (u, v, ld) => {
        if (!adj.has(u)) adj.set(u, new Set());
        adj.get(u).add(v);
        edgeMap.set(`${u}->${v}`, ld);
    };

    // ✅ 정방향 + 역방향 모두 추가
    for (const ld of links) {
        const u = Number(ld.StrtInloNo);
        const v = Number(ld.endInloNo);
        if (isNaN(u) || isNaN(v)) continue;
        addEdge(u, v, ld);
        addEdge(v, u, ld); // ← 이 줄이 핵심
    }

    // BFS
    const s = Number(startInloNo), t = Number(targetInloNo);
    const q = [s], visited = new Set([s]);
    const prev = new Map(); // node -> { prev, viaEdgeKey }
    while (q.length) {
        const cur = q.shift();
        if (cur === t) break;
        const neigh = adj.get(cur) || [];
        for (const nxt of neigh) {
        if (visited.has(nxt)) continue;
        visited.add(nxt);
        prev.set(nxt, { prev: cur, via: `${cur}->${nxt}` });
        q.push(nxt);
        }
    }
    if (!visited.has(t)) { console.warn("[highlightPath_Inlo] 경로 없음:", s, "->", t); return; }

    // 경로 복원 & 색칠
    const edges = [];
    for (let x = t; x !== s; ) {
        const step = prev.get(x); if (!step) break;
        edges.push(step.via);
        x = step.prev;
    }

    m.startTransaction("highlight-inlo-path");
    for (const ek of edges) {
        // 정/역방향 중 실제 존재하는 쪽을 찾아 색칠
        const ld = edgeMap.get(ek) || edgeMap.get(ek.split("->").reverse().join("->"));
        if (ld) m.setDataProperty(ld, "color", color);
    }
    m.commitTransaction("highlight-inlo-path");
    }

    function initDiagram() {
        
        const $ = go.GraphObject.make;
        const myDiagram = $(go.Diagram, {
            model: $(go.GraphLinksModel, { linkKeyProperty: "key" },),
            initialContentAlignment: go.Spot.Center,  
            initialDocumentSpot:go.Spot.Center ,
            isReadOnly: true,
            //ModelChanged: onChange,             
        })      
        
        myDiagram.add(
            new go.Part({ // this Part is not bound to any model data    
                layerName: 'Background',
                position: new go.Point(0, 0),
                selectable: false,
                pickable: false
              })
              
            );
      
        myDiagram.nodeTemplate  =
            new go.Node(
                "Vertical",
                { locationObjectName: "PORT", locationSpot: go.Spot.Center, selectable: false, pickable: true,  cursor: "pointer", click: (e, node) => {    console.log("clicked sink/source node:", node.data);        props.onNodeClick?.(node.data, node);
                                                                                                                                                        if(ugrpNo !== 1024){
                                                                                                                                                            // 1) 전체 링크 색상 초기화 
                                                                                                                                                            resetLinkColors(myDiagram, "#b0b0b0");
                                                                                                                                                            const start = node.data.inloNo;     // 시작 inloNo
                                                                                                                                                            const target = node.data.sourceInlono;              // 예: 조합공용 inloNo (루트)
                                                                                                                                                            // 2) 이 노드에 연결된 링크만 강조
                                                                                                                                                            highlightPath_Inlo(myDiagram, start, target, "#ff6b6b");

                                                                                                                                                            // 2) 노드 테두리 하이라이트
                                                                                                                                                            resetNodeBorders(myDiagram, "#c8c8c8");
                                                                                                                                                            highlightNodeBorder(myDiagram, node, "#2cc01eff");
                                                                                                                                                            highlightSourceNode(myDiagram, node, "#1e90ff");
                                                                                                                                                        }    

                                                                                                                                                        
                }}
            )
                .bindTwoWay("desiredSize", "size", go.Size.parse, go.Size.stringify)
                .bindTwoWay('location', 'loc', go.Point.parse, go.Point.stringify)
                .add(
                    new go.Panel("Auto")
                        .add(
                            new go.Shape("RoundedRectangle",
                                { strokeWidth: 4, fill: "#c8c8c8", margin: 4, width: 100, height: 40, })
                                .bind('stroke', 'color')
                        )
                        .add(
                            new go.TextBlock({ margin: 8, editable: true ,font: '10pt Roboto, Helvetic , Arial, sans-serif',})
                                .bind("text", "inloName"),
                        )
                )

        myDiagram.nodeTemplateMap.add('sinkSourceInfo',      
            new go.Node(
                "Vertical"
                , { locationObjectName: "PORT", locationSpot: go.Spot.Center, selectable: false, pickable: true,  cursor: "pointer", click: (e, node) => {          }     })
                .bindTwoWay("desiredSize", "size", go.Size.parse, go.Size.stringify)
                .bindTwoWay('location', 'loc', go.Point.parse, go.Point.stringify)
                .add(
                    new go.Panel("Vertical")
                        .add(new go.Panel("Table",
                            {
                                defaultRowSeparatorStroke: "black",
                                defaultColumnSeparatorStroke: "black"
                            })
                            .add( // these three elements are the content of the Table Panel              
                                new go.TextBlock({
                                    row: 0, column: 1, width: 100, height: 15,
                                    font: 'bold 10pt Roboto, Helvetic , Arial, sans-serif', margin: 0, textAlign: "center", background: "white"
                                })                                   
                                    .bind("text", "group"),
                                new go.TextBlock({
                                    row: 1, column: 1, width: 100,
                                    margin: 0, textAlign: "center"
                                })
                                     .bind('background', 'group', (b) => (b=="source" ? "#38aecd" : "#94c736"))
                                    .bind("text", "flowRate"),
                                new go.TextBlock({
                                    row: 2, column: 1, width: 100,
                                    margin: 0, textAlign: "center", background: "#38aecd"
                                })
                                    .bind("text", "pressureLoss")
                            ),
                        )

                ) 
            )       

        myDiagram.linkTemplate = new
            go.Link(
                {
                    layerName: "Background",
                    routing: go.Link.Orthogonal,          
                    resegmentable: true,
                    fromSpot: go.Spot.RightSide,
                    toSpot: go.Spot.LeftSide,
                    selectable: false, pickable: false
                     
                })
            // make sure links come in from the proper direction and go out appropriately
            .bindTwoWay("fromSpot", "fromSpot", go.Spot.parse)
            .bindTwoWay("toSpot", "toSpot", go.Spot.parse)
            .bindTwoWay('points')
            // mark each Shape to get the link geometry with isPanelMain: true
            .add(
                // mark each Shape to get the link geometry with isPanelMain: true
                new go.Shape({ isPanelMain: true, stroke: 'black', strokeWidth: 15 }),
                new go.Shape({ isPanelMain: true, strokeWidth: 10 })
                    .bind('stroke', 'color'),
                new go.Shape({
                    isPanelMain: true,
                    stroke: 'white',
                    strokeWidth: 3,
                    name: 'PIPE',
                    strokeDashArray: [10, 10]
                })
            )            

        myDiagram.toolManager.panningTool.isEnabled = false;
        myDiagram.toolManager.draggingTool.isEnabled = false;   
       
       
        setMyDiagram(myDiagram);
              
        return myDiagram;
    }

    function handleDiagramEvent() {
        if (myAnimation) myAnimation.stop();
        if(myDiagram === null) return;
        // Animate the flow in the pipes
        let ani = new go.Animation();
        ani.easing = go.Animation.EaseLinear;
        myDiagram.links.each(link => {
            ani.add(link.findObject("PIPE"), "strokeDashOffset", 20, 0)
        });
        // Run indefinitely
        ani.runCount = Infinity;
        ani.start();

        setMyAnimation(ani);    
    }

    const saveData = () => {        
        console.log(myDiagram.model.nodeDataArray);
        console.log(myDiagram.model.linkDataArray);
        handleDiagramEvent();
      };

      /*save 하면 살아있는데 랜더링 전에는 안됨 ..*/ 
      
    return (    
        <>

        {nodeDataArray.length !== 0? <ReactDiagram
                divClassName="diagram-component"
                initDiagram={initDiagram}
                nodeDataArray={nodeDataArray}
                linkDataArray={linkDataArray} /> : <div class="diagram-component"></div>}
        
        </>        
    );
};

export default FxRoutingDiagram;


